export const CLIENT_TYPES = {
  ALL: 'tutti',
  CEDENTE: 'cedente',
  CESSIONARIO: 'cessionario',
  OTHER: 'altro',
};

export const CLIENT_TYPE_LABELS = {
  [CLIENT_TYPES.CEDENTE]: 'Cedente',
  [CLIENT_TYPES.CESSIONARIO]: 'Cessionario',
  [CLIENT_TYPES.OTHER]: 'Altro',
};

export const CLIENT_TYPE_BADGE_CLASS = {
  [CLIENT_TYPES.CEDENTE]: 'bg-[var(--primary-soft)] text-[var(--primary)] border-[var(--border-strong)]',
  [CLIENT_TYPES.CESSIONARIO]: 'bg-[var(--success-soft)] text-[var(--success-text)] border-[var(--success-border)]',
  [CLIENT_TYPES.OTHER]: 'bg-[var(--surface-raised)] text-[var(--text-primary)] border-[var(--border)]',
};
